import React, { Component } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withRouter } from 'react-router-dom'

// Material UI
import { withTheme, withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Modal from '@material-ui/core/Modal'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

import Utils from '../resources/Utils'
import LogoWhatsapp from '../resources/images/whatsapp.png'

// Actions
import { requestConfirmCode, requestSendMensajeToConfirm } from '../actions/actions'

function getModalStyle() {
  const top = 50
  const left = 50

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  }
}

const styles = theme => ({
  modalContainer: {
    overflow: 'scroll'
  },
  container: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 5,
    [theme.breakpoints.down('xs')]: {
      background: 'white',
      width: '90%',
      height: '100%',
      paddingTop: '20%',
      paddingLeft: '5%',
      paddingRight: '5%'
    }
  },
  modalTitle: {
    fontWeight: 600
  },
  largeTextField: {
    width: '100%',
    marginTop: 12
  },
  smallTextField: {
    width: '30%',
    paddingRight: '3%',
    marginTop: 12
  },
  LastSmallTextField: {
    width: '33%',
    marginTop: 12
  },
  actions: {
    float: 'right',
    marginTop: 32
  },
  primaryButton: {
    marginLeft: 16,
    fontWeight: 600,
    fontSize: 14
  },
  primaryButton100: {
    marginTop: 12,
    width: '100%',
    fontWeight: 600,
    fontSize: 14
  }
})

class ConfirmPhoneModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      codigo: '',
      openSnack: false,
      errorMessage: '',
      seconds: 0,
      maxSecondsToWait: 60
    }

    this.isDataFormValid = this.isDataFormValid.bind(this)
    this.handleChangeCodigo = this.handleChangeCodigo.bind(this)
    this.reSendCode = this.reSendCode.bind(this)

    this.handleConfirm = this.handleConfirm.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.clearData = this.clearData.bind(this)
    this.handleCloseSnackbar = this.handleCloseSnackbar.bind(this)
    this.handleRender = this.handleRender.bind(this)
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.init.confirmCode !== this.props.init.confirmCode) {
      const { status, detail } = this.props.init.confirmCode
      if(status === Utils.constants.status.ok){
         this.props.handleClose()
      } else {
        this.setState({
          openSnack: true,
          errorMessage: detail
        } )
      }
    }
    if (prevProps.init.mensajeToConfirm !== this.props.init.mensajeToConfirm) {
      const { status, detail } = this.props.init.mensajeToConfirm
      if(status === Utils.constants.status.ok){
        this.setState({ seconds: 0, codigo: '' })
      } else {
        this.setState({ 
          openSnack: true,
          errorMessage: detail ? detail:  "No se ha podido enviar el mensaje, vuelta a intentarlo."
        })
      }
    }
  }

  startTimer() {
    this.timer = setInterval(this.countDown, 1000);
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds + 1;
    this.setState({
      seconds: seconds,
    });
  }

  isDataFormValid() {

    const { codigo } = this.state

    if(codigo.length === 4){
      this.handleConfirm()
    } else {
      this.setState({ openSnack: true, errorMessage: Utils.getMessages().ConfirmPhoneModal.invalidCodeForm })
    }
    
  }

  handleChangeCodigo(event) {

    if(event.target.value.toString().length > 4){
      event.preventDefault()
      return
    }
    this.setState({codigo: event.target.value})
   
  }

  reSendCode(){
    this.props.requestSendMensajeToConfirm({ numbers:this.props.numberPhone, country_code: this.props.countryCode, })
  }

  handleConfirm() {
    this.props.requestConfirmCode({ code: this.state.codigo, numbers:this.props.numberPhone, country_code: this.props.countryCode, })
  }

  handleCloseSnackbar() {
    this.setState({errorMessage: '', openSnack: false})
  }

  handleClose() {
    this.clearData()
    this.props.handleClose()
    clearInterval(this.countDown)
  }


  handleRender() {
    this.setState({codigo:'', seconds: 0})
    this.startTimer()
  }

  clearData() {
    this.setState({
      codigo: '',
      seconds: 0
    })
  }

  render() {
    const { classes } = this.props
    const { seconds, maxSecondsToWait } = this.state

    return (
      <Modal
        open={this.props.open}
        onEscapeKeyDown={this.handleClose}
        onBackdropClick={this.handleClose}
        className={classes.modalContainer}
        onRendered={this.handleRender}
      >
        <div style={getModalStyle()} className={classes.container}>
          <Typography variant="h4" className={classes.modalTitle}>
            {Utils.getMessages().ConfirmPhoneModal.title}
          </Typography>
          <Typography variant="body1" style={{marginTop: 8}}>
            {Utils.getMessages().ConfirmPhoneModal.description}
          </Typography>
            <br/>
            <img src={LogoWhatsapp} alt="logo" style={{width:"30px", height:"30px"}} />
            <TextField
              className={classes.largeTextField}
              label={Utils.getMessages().ConfirmPhoneModal.placeholderCodigo}
              type="text"
              value={this.state.codigo}
              onChange={this.handleChangeCodigo}
              autoFocus
            />

            { 
              seconds >= maxSecondsToWait ?
                <Button
                  className={classes.primaryButton100}
                  variant="contained"
                  color="primary"
                  onClick={this.reSendCode}
                >
                  {Utils.getMessages().ConfirmPhoneModal.resend}
              </Button> 
              : null
            }
            
            <div className={classes.actions}>
              <Button
                  onClick={this.handleClose}
                >
                {Utils.getMessages().ConfirmPhoneModal.cancelButton}
              </Button>
              <Button
                className={classes.primaryButton}
                variant="contained"
                color="primary"
                onClick={this.isDataFormValid}
              >
                {Utils.getMessages().ConfirmPhoneModal.confirmButton}
              </Button>
            </div>
  
          <Snackbar
            autoHideDuration={5000}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            open={this.state.openSnack}
            onClose={this.handleCloseSnackbar}
            message={
              <span>{this.state.errorMessage}</span>
            }
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.handleCloseSnackbar}
              >
                <CloseIcon />
              </IconButton>
            ]}
          />
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({ ...state })

const mapDispatchToProps = dispatch => {
  return {
    requestConfirmCode: (data) => {
      dispatch(requestConfirmCode(data))
    },
    requestSendMensajeToConfirm: (data) => {
      dispatch(requestSendMensajeToConfirm(data))
    }
  }
}

export default compose(
  withRouter,
  withTheme,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ConfirmPhoneModal)
